/**
 * @file
 * Behaviors for the Clickable List.
 */

!((Drupal, $) => {
  'use strict';

  /**
   * Setup and attach the Clickable List behaviors.
   *
   * @type {Drupal~behavior}
   */

  Drupal.behaviors.clickableList = {
    attach: function() {
      // Declaring variables, targeting the output of our twig
      const stepListElements = $('.playlist [data-click-step]');
      const dotElements = $('.playlist [data-click-dot]');
      const imageElements = $('.playlist [data-click-img]');

      // Initialization - adding classes to first elements in the lists
      $('.playlist__dot')
        .eq(0)
        .addClass('playlist-active-step');
      $('.playlist__media')
        .eq(0)
        .addClass('playlist-active-step');
      $('.playlist__item')
        .eq(0)
        .addClass('playlist-active-step');
      // click listener for list items
      $('.playlist [data-click-step]').on('click', function() {
        let clickedStep = $(this).attr('data-click-step');
        let dotElementToUpdate = $(`[data-click-dot="${clickedStep}"]`);
        let imgElementToUpdate = $(`[data-click-img="${clickedStep}"]`);

        for (let i = 0; i < stepListElements.length; i++) {
          stepListElements.eq(i).removeClass('playlist-active-step');
        }
        $(this).addClass('playlist-active-step');

        for (let i = 0; i < dotElements.length; i++) {
          dotElements.eq(i).removeClass('playlist-active-step');
        }
        dotElementToUpdate.addClass('playlist-active-step');

        for (let i = 0; i < imageElements.length; i++) {
          imageElements.eq(i).removeClass('playlist-active-step');
          var videoPlaylistIframe = $('.playlist iframe')[i].contentWindow;
          videoPlaylistIframe.postMessage(
            '{"event":"command","func":"stopVideo"}',
            '*'
          );
        }
        imgElementToUpdate.addClass('playlist-active-step');
      });
      // click listener for dots, fires associated step's click event
      $('.playlist [data-click-dot]').on('click', function() {
        let clickedDot = $(this).attr('data-click-dot');
        let stepItemTarget = $(`[data-click-step="${clickedDot}"]`);
        stepItemTarget.click();
      });
    }
  };
})(Drupal, jQuery);
